import React from 'react';
import { connect } from 'react-redux';
import { quoteFormSelector, splitTrafficIdSelector } from 'ctm-selectors';
import { getLabelFromCode, getColourLabel } from '../../../core/state_selectors';
import { EditMyDetails } from './edit_my_details';

/**
 * Returns Edit My Details Container with Snapshot Links
 * @param {Object} props - the incoming set of props
 * @return {Node} EditMyDetails returns EditMyDetails component
 */
const _EditMyDetailsContainer = (props) => <EditMyDetails {...props} />;

/**
 * Extract the following data from the store
 * @param {Object} state - Redux store state.
 * @return {Object} - The state attributes to add to props.
 */
export const mapStateToProps = (state) => {
    const series = JSON.parse(JSON.stringify(state.getIn(['vertical', 'quote', 'apiResponses', 'series']) || []));
    const currentSeries = state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'redbookCode']) || '';
    return {
        series: series.find((s) => s.redbookCode === currentSeries) || null,
        badge: getLabelFromCode(state, 'coverDetail.vehicle.badge', 'vertical.quote.apiResponses.badge'),
        make: getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes') || 'Make',
        year: getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years') || 'Year',
        model: getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models') || 'Model',
        body: getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies') || 'Body',
        transmission: getLabelFromCode(state, 'coverDetail.vehicle.transmission', 'vertical.quote.apiResponses.transmissions') || 'Transmission',
        fuel: getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel') || 'Fuel',
        colour: getColourLabel(state) || 'Colour',
        description: state.getIn('vertical.quote.apiResponses.description'.split('.')) || 'Description',
        firstName: quoteFormSelector(state).getIn(['applicant', 'firstName']) || '',
        lastName: quoteFormSelector(state).getIn(['applicant', 'lastName']) || '',
        email: quoteFormSelector(state).getIn(['applicant', 'email']) || '',
        mobile: quoteFormSelector(state).getIn(['applicant', 'mobile']) || '',
        phone: quoteFormSelector(state).getIn(['applicant', 'phone']) || '',
        coverType: quoteFormSelector(state).getIn(['coverDetail', 'coverType']),
        damaged: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'damaged']),
        securityFeatures: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'securityFeatures']) || '',
        finance: quoteFormSelector(state).getIn(['coverDetail', 'financeType']),
        currentlyInsured: quoteFormSelector(state).getIn(['coverDetail', 'currentlyInsured']),
        previousInsurer: quoteFormSelector(state).getIn(['coverDetail', 'previousInsurer']),
        annualKilometres: quoteFormSelector(state).getIn(['coverDetail', 'annualKilometres']),
        useType: quoteFormSelector(state).getIn(['coverDetail', 'useType']),
        commencementDate: quoteFormSelector(state).getIn(['coverDetail', 'commencementDate']),
        overnightParkingPostcode: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'address', 'postcode']),
        overnightParkingType: quoteFormSelector(state).getIn(['coverDetail', 'overnightParking', 'parkingType']),
        hasYoungerDriver: quoteFormSelector(state).getIn(['coverDetail', 'hasYoungerDriver']),
        youngerDriverGender: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'gender']) || '',
        youngerDriverLicenceType: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'licenceType']) ?? '',
        comprehensiveInsured: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'comprehensiveInsured']),
        comprehensiveInsuredYears: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'comprehensiveInsuredYears']),
        youngerDriverDob: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'dob']) || '',
        youngerDriverLicenceAge: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'licenceAge']) || '',
        youngerDriverAnnualKilometres: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'annualKilometres']) || '',
        factoryOptions: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'factoryOptions']),
        nonStandardAccessories: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'nonStandardAccessories']),
        modified: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'modified']),
        driverGender: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'gender']) || '',
        driverDob: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'dob']),
        driverLicenceType: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'licenceType']) ?? '',
        driverEmployment: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'employmentStatus']),
        driverAge: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'licenceAge']),
        driverPreviousClaims: quoteFormSelector(state).getIn(['coverDetail', 'driver', 'anyPreviousClaims']),
        driverPreviousClaimsCount: quoteFormSelector(state).getIn(['anyPreviousClaimsCount']),
        driverOwnsAnotherCar: quoteFormSelector(state).getIn(['coverDetail', 'ownsAnotherCar']),
        driverOwnsAnotherHome: quoteFormSelector(state).getIn(['coverDetail', 'ownsHome']),
        driverOption: quoteFormSelector(state).getIn(['coverDetail', 'driverOption']),
        splitTrafficId: splitTrafficIdSelector(state)
    };
};

const EditMyDetailsContainer = connect(mapStateToProps)(_EditMyDetailsContainer);

export { _EditMyDetailsContainer, EditMyDetailsContainer };
